<div class="container">
  <div class="tile-icon">
    <img class="" src="../../../assets/icons/hondaLink.png" alt="HondaLink" />
  </div>
  <p class="font-14 black-color text-center-align">Reset Your PIN</p>

  <div class="row">
    <div class="col-sm-5">
      <div class="form-group">
        <label>Enter New PIN</label>
        <input
          type="text"
          class="form-control"
          placeholder="Enter 4-digit PIN"
        />
      </div>
      <div class="form-group">
        <label>Confirm PIN</label>
        <input
          type="text"
          placeholder="Re-enter 4-digit PIN"
          class="form-control"
        />
      </div>
    </div>
    <div class="col-sm-2"></div>
    <div class="col-sm-5">
      <div>
        <p id="p1" class="font-12 black-color font-weight-400">PIN Should:</p>
        <p id="p2" class="font-12 grey-color font-weight-400">
          Not be a sequence of forward numbers<br />Not be a sequence of
          backward numbers<br />Not have four identical digits<br />Not be one
          of your last 3 used PINs
        </p>
      </div>
    </div>
  </div>
  <div class="action-btn-container flex justify-content-center">
    <button
      mat-flat-button
      class="edit-form-button standard-btn primar-btn btn-width"
      [routerLink]="['/resetPinSuccess']"
      (click)="onSave()"
    >
      Submit
    </button>
  </div>
  <div class="private-policy">
    <p class="font-14 black-color">
      Having Trouble? Contact Customer Support at <a href="">1-800-123-4567</a>.
    </p>
  </div>
</div>
